// default navicon
export function navicon() {
    document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {

        e.preventDefault();
        e.currentTarget.classList.toggle('site-navigation__navicon--active');
        document.querySelector('.site-navigation').classList.toggle('site-navigation--active');
        document.querySelector('.site-header__banner').classList.toggle('site-header__banner--active');
        document.body.classList.toggle('site-navigation--open');
    });
    setTimeout(function() {
        var siteHeaderBanner = document.querySelector('.site-header__banner');
        siteHeaderBanner.style.transition = 'transform 0.3s ease';
      }, 1000);

}